export const GOOGLE_MAPS_API_KEY = 'AIzaSyBPVyAeBsCWB0jbqPTKX8wSGv4oei9Q_H0';
export const GOOGLE_MAPS_ID = '9cfa58174c5c3861';
export const CDN_URL = 'https://cdn.migros.ch/mgb-producer-map';
